import axiosInstance from "../../../utils/axiosInstance"
import { BASE_URL, API_ENDPOINT_FORGOT_PASSWORD } from "../../../utils/constants";
import { createAsyncThunk } from "@reduxjs/toolkit";

const forgotPassword = createAsyncThunk("auth/forgotPassword", async (data, thunkAPI) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}${API_ENDPOINT_FORGOT_PASSWORD}`, data);
    const responseData = await res.data;
    return responseData;
  } catch (error) {
    return thunkAPI?.rejectWithValue(error?.response?.data);
  }
});
export { forgotPassword };
